<template lang="pug">
  b-row(
    class="text-center thumbnail-container")
      b-col(sm="12")
        h3 This page is currently down for maintenance.
        br
        br
        br
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>



// WEBPACK FOOTER //
// src/components/templates/Maintenance.vue